exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".quotePMargin[data-v-69c2c23c]{margin:0;text-align:left!important}.md-direction-bottom-right[data-v-69c2c23c]{width:18%!important}.md-flex-xsmall-100[data-v-69c2c23c]{min-width:100%;flex:0 1 100%}.center[data-v-69c2c23c]{text-align:center}.b-form-input-container[data-v-69c2c23c]{margin:4px 0 12px!important}.activeClass[data-v-69c2c23c]{display:none}.error[data-v-69c2c23c]{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69c2c23c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/allModuleForm/mainEnquiry.vue
// module id = 1671
// module chunks = 0